export default __webpack_public_path__ + "static/media/cp_azure_azure.d868bdff.svg";